import { EnvironmentsType } from '../global-types/feature-flags';
import { setEnabledEnvironments } from '../utils/utility/set-enabled-environments';

export const useFeatureFlags = () => {
  /**
   * Flags
   */

  // Should only show in US dev
  const DISPLAY_ZOOM_DEV = setEnabledEnvironments([]); // Enable on dev for local development

  // Whether app should generate FE previews using canvasJson. Temporary to test previews, can remove after FE previews is tested and released
  // If CANVAS_JSON_PREVIEWS is false, FE will use printJson to generate previews
  const CANVAS_JSON_PREVIEW = setEnabledEnvironments([]);

  // feature for hiding and showing the toolbar based on if a S&S user zome is selected or not (MIMIR-3137)
  const SAS_TOOLBAR_TOGGLE = setEnabledEnvironments([]);

  // Enables or disables using the url from 'image_url' for the image added to the card in the thumbnail component (MIMIR-3180)
  const IS_URL_IMAGE_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev, // Change Flag to Dev when working locally
    EnvironmentsType.CeDev,
  ]);

  const IS_DRAWER_PAGINATION_ENABLED = setEnabledEnvironments([]);

  // Enables the new styled dynamic buttons for S&S cards (added in MIMIR-3024)
  const SAS_DYNAMIC_BUTTONS = setEnabledEnvironments([]);

  // Enables and disables components related to H Plus
  const IS_H_PLUS_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  // Enables and disables components related to loyalty (added in MIMIR-3260)
  const IS_LOYALTY_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_AUTOSAVE_PROJECTS_ENABLED = setEnabledEnvironments([]);

  // Enables and disables spellcheck functionality (MIMIR-3259)
  const IS_SPELLCHECK_ENABLED = setEnabledEnvironments([]);

  // Enables text overlays as a whole, on all implementations
  const IS_TEXTBOX_OVERLAY_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  // Enables text overlays for S&S text zones
  const IS_SNS_TEXTBOX_OVERLAY_ENABLED = setEnabledEnvironments([EnvironmentsType.UsDev]);

  // Enables text overlays for POD user added text (inside of card)
  const IS_POD_USER_TEXTBOX_OVERLAY_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  // Enables text overlays for POD template defined text zones
  const IS_POD_TEXT_ZONE_OVERLAY_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  // Enables text overlays for POD edit mode
  const IS_POD_EDIT_MODE_OVERLAY_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);
  // Enables and disables the new Photo Drawer (MIMIR-3336)
  const IS_PHOTO_DRAWER_ENABLED = setEnabledEnvironments([]);

  // Enables and disables address validation
  const IS_ADDRESS_VALIDATION_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  // Enables chatbot feature
  const IS_CHATBOT_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_ADDRESS_BULK_UPLOAD_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_MULT_ADDRESS_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_ADOBE_ANALYTICS_ENABLED = setEnabledEnvironments([EnvironmentsType.UsDev, EnvironmentsType.UsProd]);

  const IS_ENVELOPE_PRINTING_OPTIONS_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_USER_ZONE_TRANSPARENT = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
    EnvironmentsType.UkDev,
    EnvironmentsType.UkStage,
    EnvironmentsType.UkProd,
  ]);

  // Feature flag for the USPS invalid pill in the address summary or address book.
  const IS_INVALID_PILL_ENABLED = setEnabledEnvironments([]);

  // Feature flag to hide/show edit controls like scale and rotate
  const IS_FORCE_FILL_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_ADDRESS_AUTOCOMPLETE_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_ADDRESSBOOK_SORT_SELECT_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_ADDRESSBOOK_SELECTALL_ENABLED = setEnabledEnvironments([
    EnvironmentsType.UsDev,
    EnvironmentsType.UsStage,
    EnvironmentsType.UsProd,
  ]);

  const IS_ADDRESSBOOK_SEARCH_ENABLED = setEnabledEnvironments([EnvironmentsType.UsDev, EnvironmentsType.UsStage]);

  return {
    DISPLAY_ZOOM_DEV,
    SAS_TOOLBAR_TOGGLE,
    IS_URL_IMAGE_ENABLED,
    SAS_DYNAMIC_BUTTONS,
    IS_AUTOSAVE_PROJECTS_ENABLED,
    IS_ENVELOPE_PRINTING_OPTIONS_ENABLED,
    IS_H_PLUS_ENABLED,
    CANVAS_JSON_PREVIEW,
    IS_LOYALTY_ENABLED,
    IS_SPELLCHECK_ENABLED,
    IS_CHATBOT_ENABLED,
    IS_ADDRESS_VALIDATION_ENABLED,
    IS_PHOTO_DRAWER_ENABLED,
    IS_DRAWER_PAGINATION_ENABLED,
    IS_ADDRESS_BULK_UPLOAD_ENABLED,
    IS_MULT_ADDRESS_ENABLED,
    IS_ADOBE_ANALYTICS_ENABLED,
    IS_USER_ZONE_TRANSPARENT,
    IS_TEXTBOX_OVERLAY_ENABLED,
    IS_SNS_TEXTBOX_OVERLAY_ENABLED,
    IS_POD_EDIT_MODE_OVERLAY_ENABLED,
    IS_POD_USER_TEXTBOX_OVERLAY_ENABLED,
    IS_POD_TEXT_ZONE_OVERLAY_ENABLED,
    IS_INVALID_PILL_ENABLED,
    IS_FORCE_FILL_ENABLED,
    IS_ADDRESS_AUTOCOMPLETE_ENABLED,
    IS_ADDRESSBOOK_SORT_SELECT_ENABLED,
    IS_ADDRESSBOOK_SEARCH_ENABLED,
    IS_ADDRESSBOOK_SELECTALL_ENABLED,
  };
};
